import React from 'react';
import { REVIEW_STATUS } from './importReview.model';
import styles from './ImportReview.module.css';

const STATUS_PRESENTATION = {
	[REVIEW_STATUS.READY]: {
		icon: '✓',
		label: 'Lista',
		className: styles.statusReady,
	},
	[REVIEW_STATUS.AUTO_CORRECTED]: {
		icon: '↗',
		label: 'Auto-corregida',
		className: styles.statusAuto,
	},
	[REVIEW_STATUS.REVIEW_REQUIRED]: {
		icon: '!',
		label: 'Requiere revisión',
		className: styles.statusReview,
	},
	[REVIEW_STATUS.BLOCKED]: {
		icon: '×',
		label: 'Bloqueada',
		className: styles.statusBlocked,
	},
};

const MatchStatusBadge = ({ status, confidence }) => {
	const presentation =
		STATUS_PRESENTATION[status] || STATUS_PRESENTATION[REVIEW_STATUS.READY];
	const numericConfidence = Number(confidence);
	const confidenceLabel = Number.isFinite(numericConfidence)
		? `${Math.round(numericConfidence <= 1 ? numericConfidence * 100 : numericConfidence)}%`
		: undefined;

	return (
		<span className={`${styles.statusBadge} ${presentation.className}`}>
			<span aria-hidden='true' className={styles.statusIcon}>
				{presentation.icon}
			</span>
			<span>{presentation.label}</span>
			{confidenceLabel && (
				<span
					className={styles.confidence}
					aria-label={`${confidenceLabel} de similitud`}
				>
					{confidenceLabel}
				</span>
			)}
		</span>
	);
};

export default MatchStatusBadge;
